<div class="chart">
  <div
    [id]="id"
    class="charts"
    style="width: 100%; text-transform: capitalize"
    [style.height.px]="graphHeight"
  ></div>
</div>
